// Copyright (c) Bentley Systems
type DeleteFileProps = {
  readonly apiDefinition: () => Promise<Response>;
  readonly preDeleting: () => void;
  readonly postDeleting: () => void;
  readonly onError: (
    responseStatusCode: number,
    activityId: string | undefined,
  ) => void;
};

type DownloadedFileInfo = {
  readonly download: () => Promise<void>;
};

export const useDeleteFile = ({
  apiDefinition,
  preDeleting,
  postDeleting,
  onError,
}: DeleteFileProps): DownloadedFileInfo => {
  const download = async () => {
    try {
      preDeleting();
      const response = await apiDefinition();
      if (response.ok) {
        postDeleting();
      } else {
        const runId = response.headers.get("X-Run-Id") ?? undefined;
        onError(response.status, runId);
      }
    } catch {
      onError(0, undefined);
    }
  };

  return { download };
};
